import React from 'react';
import styles from '../NDAGenerator.module.scss';

export interface UploadSectionProps {
  customerNDAFile: File | null;
  zurichTemplateFile: File | null;
  analysisError: string | null;
  isAnalyzing: boolean;
  uploadingCustomer: boolean;
  analyzeTitle: string;
  onOpenUploadModal: (type: 'customer' | 'template') => void;
  onRemoveFile: (type: 'customer' | 'template') => void;
  onAnalyze: () => void;
  analyzeDisabled: boolean;
  analysisProgress: string;
}

const UploadSection: React.FC<UploadSectionProps> = ({
  customerNDAFile,
  zurichTemplateFile,
  analysisError,
  isAnalyzing,
  uploadingCustomer,
  analyzeTitle,
  onOpenUploadModal,
  onRemoveFile,
  onAnalyze,
  analyzeDisabled,
  analysisProgress
}) => {
  return (
    <div className={styles.uploadSection}>
      <div className={styles.uploadInstructions}>
        <h3>Upload Documents for Analysis</h3>
        <p>
          Upload <strong>customer/partner NDA documents</strong> to analyze
          compliance with Zurich&#39;s requirements.
        </p>
      </div>
      <div className={styles.fileUploadGrid}>
        <div className={styles.uploadCard}>
          <h4>Customer NDA</h4>
          <p className={styles.required}>Required</p>
          {customerNDAFile ? (
            <div className={styles.uploadedFile}>
              <span className={styles.fileName}>📄 {customerNDAFile.name}</span>
              <button
                className={styles.removeFile}
                onClick={() => onRemoveFile('customer')}
              >
                🗑️
              </button>
            </div>
          ) : (
            <button
              className={styles.uploadButton}
              onClick={() => onOpenUploadModal('customer')}
              style={{
                backgroundColor: 'var(--brand-primary, #1e88e5)',
                color: 'var(--on-brand-primary, #ffffff)'
              }}
            >
              Upload NDA Document
            </button>
          )}
        </div>
        <div className={styles.uploadCard}>
          <h4>Custom Zurich Template</h4>
          <p className={styles.optional}>
            Optional - Uses built-in Zurich templates by default
          </p>
          {zurichTemplateFile ? (
            <div className={styles.uploadedFile}>
              <span className={styles.fileName}>
                📄 {zurichTemplateFile.name}
              </span>
              <button
                className={styles.removeFile}
                onClick={() => onRemoveFile('template')}
              >
                🗑️
              </button>
            </div>
          ) : (
            <button
              className={styles.uploadButton}
              onClick={() => onOpenUploadModal('template')}
              style={{
                backgroundColor: 'var(--brand-primary, #1e88e5)',
                color: 'var(--on-brand-primary, #ffffff)'
              }}
            >
              Upload Template (Optional)
            </button>
          )}
        </div>
      </div>
      {analysisError && (
        <div className={styles.errorMessage}>{analysisError}</div>
      )}
      <div className={styles.analyzeSection}>
        <button
          className={styles.analyzeButton}
          onClick={onAnalyze}
          disabled={analyzeDisabled}
          title={analyzeTitle}
        >
          {isAnalyzing
            ? analysisProgress || 'Analyzing...'
            : 'Analyze Document'}
        </button>
      </div>
    </div>
  );
};

export default UploadSection;
